module.exports = __webpack_public_path__ + "img/bg-y.044966e8.png";